// extracted by mini-css-extract-plugin
export default {"Badge":"Styles_Badge__sbSl3"};